var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{on:{"click":_vm.abrir}},[_vm._v(" abrir ")]),_vm._v(" HOLA MUNDO ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }